import React from 'react';

const ArrowIcon = ({ size = 18, color = 'currentColor', strokeWidth = 2.6 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <line
      x1="1.5"
      y1="-1.5"
      x2="15.6277"
      y2="-1.5"
      transform="matrix(1 -8.33681e-08 -9.18921e-08 -1 3.15039 8.79675)"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
    <path
      d="M10.5255 19.0659L2.08081 10.283L10.5255 1.5"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
  </svg>
);

export default ArrowIcon;
